module.exports = __webpack_public_path__ + "img/Eagle.2962cbc3.jpg";